import { lastNDaysRange, toIsoDate } from './date-range';

export interface DateRangePreset {
  id: string;
  label: string;
  days: number;
}

export const DATE_RANGE_PRESETS: DateRangePreset[] = [
  { id: '7d', label: 'Last 7 Days', days: 7 },
  { id: '14d', label: 'Last 14 Days', days: 14 },
  { id: '30d', label: 'Last 30 Days', days: 30 },
  { id: '60d', label: 'Last 60 Days', days: 60 },
  { id: '90d', label: 'Last 90 Days', days: 90 },
  { id: '6mo', label: 'Last 6 Months', days: 180 },
  { id: '1y', label: 'Last Year', days: 365 }
];

export const DEFAULT_PRESET_ID = '60d';

export const findPreset = (id: string): DateRangePreset | undefined =>
  DATE_RANGE_PRESETS.find((p) => p.id === id);

export const presetToRange = (
  id: string,
  now: Date = new Date()
): { dos_start: string; dos_end: string } => {
  const preset = findPreset(id) ?? findPreset(DEFAULT_PRESET_ID)!;
  return lastNDaysRange(preset.days, now);
};

const SHORT_MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

const formatShort = (iso: string): string => {
  const d = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return `${SHORT_MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}`;
};

export const formatPillLabel = (
  presetId: string,
  range: { dos_start: string; dos_end: string }
): string => {
  const preset = findPreset(presetId);
  if (preset) return preset.label;
  return `${formatShort(range.dos_start)} \u2013 ${formatShort(range.dos_end)}`;
};

export const isoToDate = (iso: string): Date =>
  new Date(`${iso}T00:00:00Z`);

export const dateToIso = (date: Date): string => toIsoDate(date);
